export const variables = {
    API_URL: "https://api-simtb.master-planner.net/api/",
    // API_URL: "https://localhost:7214/api/",
    PHOTO_URL: "Images"
}